// app/javascript/lib/bitcoinAddressValidator.js

import validate from "bitcoin-address-validation";

export function isValidMainstreamBitcoinAddress(address) {
  if (typeof address !== "string") return false;

  // Fast reject (cheap)
  if (
    !address.startsWith("1") &&
    !address.startsWith("3") &&
    !address.startsWith("bc1")
  ) {
    return false;
  }

  // Checksum + encoding validation
  if (!validate(address)) {
    return false;
  }

  // ---- Type-level restrictions ----

  // P2PKH (legacy)
  if (address.startsWith("1")) {
    return address.length >= 26 && address.length <= 35;
  }

  // P2SH (legacy)
  if (address.startsWith("3")) {
    return address.length === 34;
  }

  // Bech32 / Bech32m (segwit / taproot)
  if (address.startsWith("bc1")) {
    const lower = address.toLowerCase();

    // P2WPKH (v0 keyhash)
    if (lower.startsWith("bc1q") && address.length === 42) {
      return true;
    }

    // P2WSH (v0 scripthash)
    if (lower.startsWith("bc1q") && address.length === 62) {
      return true;
    }

    // P2TR (taproot v1, bech32m)
    if (lower.startsWith("bc1p") && address.length === 62) {
      return true;
    }

    return false;
  }

  return false;
}
